/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React from "react";
import styled from "styled-components";
import Icon from "../../ui/Icon";
import Text from "../../ui/Text";

const StyledEmptyStep = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 24px;
`;

const EmptyStep = ({ message }) => {
  return (
    <StyledEmptyStep>
      <Icon.InfoCircle color="secondary" size={Icon.SIZE.XL} />
      <Text size="large">{message}</Text>
    </StyledEmptyStep>
  );
};

export default EmptyStep;
